<template>
  <div class="shipment-counts-component">
    <div class="shipment-count flex basis-1/2">
      <img class="h-[65px]" :src="OpenBoxIcon" :alt="t('site_pro.new_shipments')" />

      <div class="ml-4 p-2">
        <div class="text-sm wl:text-base">{{ t('site_pro.new_shipments') }}</div>
        <div class="font-primary font-bold text-text1 text-xl pt-2 dark:text-dmText1 wl:text-base">
          {{ shipzeeProContent.newPackagesCount }}
        </div>
      </div>
    </div>

    <div v-if="isShipzee" class="shipment-counts-separator-wrap">
      <div class="shipment-counts-separator" />
    </div>

    <div class="shipment-count flex basis-1/2">
      <img class="h-[65px]" :src="ClosedBoxIcon" :alt="t('site_pro.total_shipped')" />

      <div class="ml-4 p-2">
        <div class="text-sm wl:text-base">{{ t('site_pro.total_shipped') }}</div>
        <div class="font-primary font-bold text-text1 text-xl pt-2 dark:text-dmText1 wl:text-base">
          {{ shipzeeProContent.shippedPackagesCount }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import OpenBoxIcon from '~/assets/icons/open-box.png'
import ClosedBoxIcon from '~/assets/icons/closed-box.png'
import { useSiteProContentStore } from '~/store/shipzeeProContentStore'

const shipzeeProContent = useSiteProContentStore()
const { t } = useLang()
const { isShipzee } = useTheme()
</script>

<style lang="postcss" scoped>
.shipment-counts-component {
  @apply flex flex-col 2xl:flex-row bg-white p-3 rounded-md w-full dark:bg-dmGray2;

  .shipment-counts-separator-wrap {
    @apply flex my-2 2xl:my-0;
    .shipment-counts-separator {
      @apply h-[1px] w-full bg-neutral6 2xl:w-[1px] 2xl:h-full;
    }
  }
}
</style>

<style lang="postcss" scoped>
.wl {
  .shipment-counts-component {
    @apply flex-row 2xl:flex-col bg-white p-0 lg:p-3 rounded-md gap-4;

    .shipment-count {
      @apply border-neutral6 border p-3 !basis-full w-full rounded-sm;

      img {
        @apply hidden;
      }

      > div {
        @apply flex gap-4 justify-between ml-0 items-center w-full p-0;

        > * {
          @apply font-medium p-0;
        }
      }
    }
  }
}
</style>
